import { Component, Input, OnInit } from '@angular/core'
import { MailTab, MailTabInterface } from '@app/mailbox/components/mailbox-tabs/mailbox-tabs.component'
import { LoaderService } from '@core/services/loader.service'

@Component({
	selector: 'app-correspondence-with-client',
	templateUrl: './correspondence-with-client.form.html',
	styleUrl: './correspondence-with-client.form.scss',
})
export class CorrespondenceWithClientForm implements OnInit {
	@Input() orderID!: string
	@Input() entityName!: string
	@Input() pageType: MailTab = 'inbox'
	isLoading = false

	mailboxTabs: MailTabInterface[] = [
		{ tabId: 'inbox', label: 'Inbox', icon: 'inbox' },
		{ tabId: 'outbox', label: 'Outbox', icon: 'send' },
	]

	constructor(private loaderService: LoaderService) {}

	ngOnInit(): void {
		this.loaderService.enable()
	}

	onPageTypeChange(type: MailTab): void {
		this.loaderService.enable(async () => {
			setTimeout(() => {
				this.pageType = type
				this.isLoading = true
				setTimeout(() => {
					this.isLoading = false
				})
			}, 50)
		})
	}
}
